export default function ($translate) {
    return {
        KEYS: {
            COURSY_CONTENT: 'COURSY_CONTENT',
            COURSY_SCORM: 'COURSY_SCORM',
            LEARNDASH: 'LEARNDASH',
            SCORM: 'SCORM',
            FILE: 'FILE'
        },
        LABELS: {
            COURSY_CONTENT: $translate.instant('course.materialSource.Coursy content'),
            COURSY_SCORM: $translate.instant('course.materialSource.Uploaded material'),
            LEARNDASH: $translate.instant('course.materialSource.Coursy materials'),
            SCORM: $translate.instant('course.materialSource.SCORM training'),
            FILE: $translate.instant('course.materialSource.File')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/trainingMaterialType/index.js